module.exports = __webpack_public_path__ + "static/media/permablok.3d0682ee.svg";